<template>
  <div class="field" :class="{ 'has-error': $attrs.error, 'animation-shake': $attrs.error && $attrs.formShake }">
    <label v-if="$attrs.label" v-bind="$attrs" class="text-black">{{ $attrs.label }}</label>
    <slot />
    <div v-if="$attrs.error" class="error pt-1 flex items-center">
      <DrIcon svg="close-solid" class="mr-1 pointer-events-none" />
      <small>{{ $attrs.error }}</small>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

<style>
.has-error input,
.has-error textarea,
.has-error select {
  @apply border border-red-650;
}

.field {
  animation-duration: 0.5s;
  animation-fill-mode: both;
  transition: all 0.3s ease;
}

</style>
